import React from "react";
import SupportLayout from "../support/SupportLayout";
import DriverInterventionsContent from "../admin/components/DriverInterventionsContent";

const SupportExecutiveDriverIntervention = () => {
  return (
    <SupportLayout userRole="SE">
      <DriverInterventionsContent useOwnLayout={false} userRole="SE" />
    </SupportLayout>
  );
};

export default SupportExecutiveDriverIntervention;
